import styled from 'styled-components';

export default styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 7em;
  height: 6.2em;
  margin: 0;
  border: 0;
  border-radius: 15px;
  text-decoration: none;
  color: white;
  background-color: rgba(255, 255, 255, 0.2);
  text-align: center;
  cursor: pointer;
  outline: none;
  font-size: 1.2em;
  font-weight: 500;
  user-select: none;
  &:hover {
    background-color: rgba(255, 255, 255, 0.4);
  }
  &:active {
    background-color: rgba(255, 255, 255, 0.6);
    outline: none;
  }
  &:focus {
    background-color: rgba(255, 255, 255, 0.4);
    outline: none;
  }
`;
